export const IS_DEV = import.meta.env.DEV;
const IS_STAGING_BUILD = import.meta.env.VITE_USE_STAGING === 'true';
const USE_STAGING = IS_DEV || IS_STAGING_BUILD;

enum DevEnv {
  STAGING = 'staging',
  LOCAL = 'local',
  LOCAL_PROD = 'local-prod', // local services + prod credentials (use with bun dev:prod)
}
const DEV_ENV = DevEnv.STAGING as DevEnv; // <-- change here to switch between local, staging, or local-prod

const STAGING_HOST_MAP = {
  [DevEnv.STAGING]: 'https://staging-api.agavehealth.com',
  [DevEnv.LOCAL]: 'https://localhost:4000',
  [DevEnv.LOCAL_PROD]: 'https://localhost:4000',
};

export const API_URL = USE_STAGING
  ? `${STAGING_HOST_MAP[DEV_ENV]}/v2/api`
  : 'https://api.agavehealth.com/v2/api';

export const AUTH_URL = USE_STAGING
  ? `${STAGING_HOST_MAP[DEV_ENV]}/v2/auth`
  : 'https://api.agavehealth.com/v2/auth';

const USE_PROD_CREDENTIALS = !USE_STAGING || DEV_ENV === DevEnv.LOCAL_PROD;

export const THERAPY_WEB_URL = 'https://therapy.agavehealth.com';

/**
 * Where a provider's public booking page lives. Its own subdomain rather than a
 * path on this one: the back office has nothing on it for members, and a link a
 * provider pastes into an email signature should not point at the admin host.
 *
 * Not switched by environment — a staging booking page would need its own
 * Netlify site, and the link shown here is the one the provider actually shares.
 */
export const BOOKING_WEB_URL = 'https://book.agavehealth.com';

export const STREAM_IO_API_KEY = USE_PROD_CREDENTIALS
  ? '36wn6npuxak3'
  : 'wj54zhx6ghb2';

export const AGAVE_STRIPE_PRICE_ID = USE_PROD_CREDENTIALS
  ? 'price_1MJDOyFPjwMtmgpRdIBC7g68'
  : 'price_1MRbv4FPjwMtmgpRTmqbSoiS';

export const DEFAULT_TIMEZONE = 'America/New_York';

export const PAGE_SIZES = [10, 30, 50];

export const STORAGE_PREFIX = 'agave';

export const DEFAULT_FILTERS = {
  page: 1,
  limit: PAGE_SIZES[1],
};
